export const FILTER_LABELS = {
  Filtro_Data_Inicio: "De: ",
  Filtro_Data_Termino: "Até: ",
  Filtro_Data_Fim: "Até: ",
  Filtro_Documento_Relacionado: "Número Nota Fiscal: ",
  Filtro_Numero_Documento_Nota: "Número Nota Fiscal: ",
  Filtro_Documento_Relacionado_Nota: "Número Pedido: ",
  Filtro_Protocolo: "Número Protocolo: ",
  Filtro_Documento_Relacionado_Agendamento: "Número Nota Fiscal: ",
};

export const PAGE_SPECIFIC_LABELS = {
 //label === "Filtro_Numero_Documento"
  DF_MO0004: "Número Pedido: ",   
  DF_LO0003: "Número Documento Transporte: ",
};